module.exports = __webpack_public_path__ + "static/media/acesso-empresa.c9c8e5fc.svg";